import React, { FC } from "react";

import Svg from "./Svg";

interface Props {
  width: string;
  height: string;
  className?: string;
}

const Message: FC<Props> = ({
  className,
  height = "1.5rem",
  width = "1.5rem",
}) => (
  <Svg
    className={className}
    height={height}
    width={width}
    viewBox="0 0 20 20"
    title="Messages icon"
  >
    <g fill="none">
      <circle cx="10" cy="10" r="10" fill="#38DD54" />
      <path
        fill="#FFF"
        d="M8.829 14.86c.379.062.77.095 1.171.095 3.314 0 6-2.229 6-4.978C16 7.228 13.314 5 10 5S4 7.228 4 9.977c0 1.795 1.146 3.369 2.864 4.244v.188c0 .529-.867 1.227-.819 1.227.867 0 1.5-.545 1.91-.672.342-.106.54-.137.874-.104z"
      />
    </g>
  </Svg>
);

export default Message;
